import http from 'hub-http/clients/apiClient';
import Raven from 'raven-js';
export const fetchUserPreferences = async () => {
  try {
    const response = await http.get('/userpreferences/v1/profile');
    return response;
  } catch (error) {
    Raven.captureException(error instanceof Error ? error : new Error('Failed to fetch user preferences'));
    throw error;
  }
};